import React, { useEffect } from 'react';
import Slider from 'react-slick';
import { Col } from 'antd';
import StyledRichText from 'components/RichText/StyledRichText';
import Text from 'components/Text';
import speakerHeadshotFallback from 'images/speaker-fallback.png';
import rightArrow from 'images/right-arrow-thin-gray.svg';
import leftArrow from 'images/left-arrow-thin-gray.svg';
import { Bio, Company, InnerContainer, SpeakerCarousel, SpeakerImage } from './styles';

const WebinarSpeakerCarousel = ({ speakers, selSpeaker }) => {
  let slider;
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    nextArrow: <img src={rightArrow} alt="right-arrow" />,
    prevArrow: <img src={leftArrow} alt="left-arrow" />,
  };

  useEffect(() => {
    slider.slickGoTo(selSpeaker);
  }, [selSpeaker]);

  return (
    <SpeakerCarousel id="webinar-speakers--carousel">
      <div className="webinar-speakers--container">
        <h5 className="webinar-speakers--title">
          Meet your speaker{speakers.length > 1 && 's'}
        </h5>
        <Slider ref={c => { slider = c }} {...settings}>
          {speakers.map((speaker, index) => {
            const { bio, firstName, lastName, photo, jobTitle, company } = speaker;
            const speakerImage = photo?.image?.fluid?.src;

            return (
              <InnerContainer gutter={{ xs: 0, sm: 16, md: 32 }} key={index}>
                <Col xs={24} lg={8} className="webinar-speakers--left-content">
                  <SpeakerImage
                    style={{ backgroundImage: `url(${speakerImage || speakerHeadshotFallback})` }}
                  />
                  <Text type="h6" className="speaker-name" size="large" marginMobile="0" color="Neutral 7">
                    {firstName} {lastName}
                  </Text>
                  <Text type="p" className="speaker-job-role">
                    {jobTitle}
                  </Text>
                  <Text type="p" className="speaker-job-title">
                    {company?.name}
                  </Text>
                </Col>
                <Col xs={24} lg={16}>
                  <Bio>{bio && <StyledRichText content={bio.json} />}</Bio>
                </Col>
              </InnerContainer>
            );
          })}
        </Slider>
      </div>
    </SpeakerCarousel>
  );
};

export default WebinarSpeakerCarousel;
